/* Aprika: accept the Matcha Latte offer with one click.
   Uses Bold's existing selection and Continue handlers; never bypasses its cart logic. */
(() => {
  'use strict';
  const offerSelector = '.offer_id_781303';
  const states = new WeakMap();
  const isAdded = button => button.getAttribute('added') === 'true' || button.textContent.trim() === 'Added';
  function inspect() {
    document.querySelectorAll('.bold-modal').forEach(modal => {
      if (!modal.querySelector(offerSelector)) return;
      modal.querySelectorAll(offerSelector + ' .add-to-cart').forEach(button => {
        if (button.textContent.trim() === 'Add to Cart') button.textContent = 'Add to cart';
      });
      let state = states.get(modal);
      if (!state) {
        state = { pending: null, scheduled: false, timer: null };
        states.set(modal, state);
        modal.classList.add('aprika-auto-continue');
      }
      const button = state.pending;
      if (!button || state.scheduled || !button.isConnected || !isAdded(button)) return;
      state.scheduled = true;
      // Let Bold finish its own click handler before continuing the selected offer.
      setTimeout(() => {
        state.scheduled = false;
        if (state.pending !== button || !modal.isConnected || !isAdded(button)) return;
        const next = modal.querySelector('[data-testid="upsell_continue"]');
        state.pending = null;
        clearTimeout(state.timer);
        if (next && !next.disabled) next.click();
        else modal.classList.remove('aprika-auto-continue');
      }, 0);
    });
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    const modal = target && target.closest('.bold-modal');
    if (!modal || !modal.querySelector(offerSelector)) return;
    inspect();
    const state = states.get(modal);
    if (target.closest('[data-testid="upsell_no_thanks"], .bold-modal__btn-close')) {
      state.pending = null;
      clearTimeout(state.timer);
      return;
    }
    const button = target.closest(offerSelector + ' .add-to-cart');
    if (!button || button.disabled || isAdded(button)) return;
    state.pending = button;
    clearTimeout(state.timer);
    // Keep the original Continue control available if Bold cannot complete selection.
    state.timer = setTimeout(() => {
      state.pending = null;
      modal.classList.remove('aprika-auto-continue');
    }, 15000);
    setTimeout(inspect, 0);
  }, true);
  const observer = new MutationObserver(inspect);
  observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['added'] });
  inspect();
})();
